import {defineStore} from "pinia";
import {type Ref, ref} from "vue";
export const useErrorStore = defineStore('error', () => {
    const errors: Ref<errorInterface[]> = ref([]);
    const report = (error: string, clear: number = 5000) => {
        const id = new Date().getTime();

        errors.value.push({
            id: id,
            error: error
        });

        setTimeout(() => clearError(id), clear);
    }
    const $reset = () => errors.value = [];
    const clearError = (id: number) => {
        const index = errors.value.findIndex((err: errorInterface) => err.id === id);

        if (index !== -1) {
            errors.value.splice(index, 1);
        }
    }

    return {
        errors,
        report,
        clearError,
        $reset
    }
});

export interface errorInterface {
    id: number,
    error: string
}